import React from 'react';
import { Clock } from 'lucide-react';

export default function HorariosLaboralesForm({ horarios, onUpdate, onToggleDia, onAplicarATodos, onRestaurar }) {
  const diasSemana = [
    { key: 'lunes', nombre: 'Lunes', abrev: 'L' },
    { key: 'martes', nombre: 'Martes', abrev: 'M' },
    { key: 'miercoles', nombre: 'Miércoles', abrev: 'X' },
    { key: 'jueves', nombre: 'Jueves', abrev: 'J' },
    { key: 'viernes', nombre: 'Viernes', abrev: 'V' },
    { key: 'sabado', nombre: 'Sábado', abrev: 'S' },
    { key: 'domingo', nombre: 'Domingo', abrev: 'D' }
  ];

  return (
    <div>
      <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Clock className="w-5 h-5 text-green-600" />
        Horarios Laborales
      </h4>
      <div className="border rounded-lg p-4 bg-gray-50">
        <div className="mb-4 flex flex-wrap items-center gap-2">
          <span className="text-sm text-gray-600">Aplicar a todos:</span>
          <button
            type="button"
            onClick={() => onAplicarATodos({ hora_inicio: '08:00', hora_fin: '18:00' })}
            className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-lg text-sm hover:bg-emerald-200 transition-colors"
          >
            8:00-18:00
          </button>
          <button
            type="button"
            onClick={() => onAplicarATodos({ hora_inicio: '08:00', hora_fin: '17:00' })}
            className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-lg text-sm hover:bg-emerald-200 transition-colors"
          >
            8:00-17:00
          </button>
          <button
            type="button"
            onClick={() => onAplicarATodos({ hora_inicio: '09:00', hora_fin: '18:00' })}
            className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-lg text-sm hover:bg-emerald-200 transition-colors"
          >
            9:00-18:00
          </button>
          <button
            type="button"
            onClick={onRestaurar}
            className="px-3 py-1 bg-gray-100 text-gray-700 rounded-lg text-sm hover:bg-gray-200 transition-colors"
          >
            Restaurar
          </button>
        </div>

        <div className="grid grid-cols-1 gap-3">
          {diasSemana.map(dia => (
            <div key={dia.key} className="flex items-center gap-4 p-3 bg-white rounded-lg border">
              <div className="flex items-center gap-2 min-w-[100px]">
                <input
                  type="checkbox"
                  checked={horarios[dia.key]?.activo || false}
                  onChange={() => onToggleDia(dia.key)}
                  className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
                />
                <span className="font-medium text-gray-700">{dia.nombre}</span>
              </div>
              
              {horarios[dia.key]?.activo && (
                <div className="flex items-center gap-2 flex-1">
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Inicio</label>
                    <input
                      type="time"
                      value={horarios[dia.key]?.hora_inicio || '08:00'}
                      onChange={(e) => onUpdate(dia.key, 'hora_inicio', e.target.value)}
                      className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-emerald-500"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Fin</label>
                    <input
                      type="time"
                      value={horarios[dia.key]?.hora_fin || '18:00'}
                      onChange={(e) => onUpdate(dia.key, 'hora_fin', e.target.value)}
                      className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-emerald-500"
                    />
                  </div>
                  <div className="text-sm text-gray-600">
                    {horarios[dia.key]?.hora_inicio && horarios[dia.key]?.hora_fin && (
                      (() => {
                        const inicio = horarios[dia.key].hora_inicio.split(':');
                        const fin = horarios[dia.key].hora_fin.split(':');
                        const horas = (parseInt(fin[0]) - parseInt(inicio[0])) + (parseInt(fin[1]) - parseInt(inicio[1])) / 60;
                        return `(${horas}h)`;
                      })()
                    )}
                  </div>
                </div>
              )}
              
              {!horarios[dia.key]?.activo && (
                <div className="flex-1 text-sm text-gray-500 italic">
                  No laborable
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-4 p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
          <p className="text-sm text-emerald-700">
            <strong>Nota:</strong> Los horarios laborales configurados aquí serán utilizados por el sistema de agendamientos inteligentes para programar mantenimientos automáticamente dentro de estos horarios.
          </p>
        </div>
      </div>
    </div>
  );
}